<template>
  <div v-if="showConfirmation" class="flex column">
    <icon v-if="!small" deleteSure xlarge class="mxa"/>
    <h3 v-if="!small" class="heading">{{ text }}</h3>
    <p class="subheading">
      {{ $t('cms.delete.ConfirmQuestion') }}
    </p>
    <div class="flex">
      <button
        @click="emitDelete"
        type="button"
        class="confirm_delete grow mr1"
        name="confirmdelete"
      >
        {{ $t('cms.delete.ConfirmButton') }}
      </button>
      <button @click="showConfirmation = false" type="button" class="box grow mr1">
        {{ $t('cms.delete.CancelButton') }}
      </button>
    </div>
  </div>
  <div v-else class="flex column">
    <icon v-if="!small" delete xlarge class="mxa"/>
    <h2 v-if="!small" class="medium heading">{{ text }}</h2>

    <p v-if="subheader" class="subheading">
      {{ subheader }}
    </p>

    <button
      @click="showConfirmation = true"
      type="button"
      class="delete"
      name="deletecampaign"
    >{{ $t('cms.delete.DeleteButton') }}</button>
  </div>
</template>

<script>
export default {
  name: 'delete',

  props: {
    small: Boolean,
    text: String,
    subheader: String,
  },

  data() {
    return {
      showConfirmation: false,
    };
  },

  methods: {
    emitDelete() {
      this.$emit('delete');
      this.showConfirmation = false;
    },
  },
};
</script>
